import { useContext, useEffect, useState } from "react";
import { IMilestone } from "models/projects/milestones/Milestone";
import { GridMetaData } from "models/grids";
import { AuthContext, IUser } from "@sagecentral/core-ui";

type GetProjectMilestonesResult = {
    milestones: IMilestone[],
    total: number
}
type UseProjectMilestonesResult = [
    IMilestone[],
    number,
    boolean,
    string | null
];

const useProjectMilestones: (projectId: string | number | undefined, gridMetadata: GridMetaData) =>
    UseProjectMilestonesResult = (projectId: string | number | undefined, gridMetadata: GridMetaData) => {

        const [result, setResult] = useState<IMilestone[]>([]);
        const [error, setError] = useState<string | null>(null);
        const [total, setTotal] = useState<number>(0);
        const [loading, setLoading] = useState<boolean>(false);

        const auth = useContext(AuthContext);

        useEffect(() => {
            if (projectId === 0) return;

            const controller = new AbortController();
            (async () => {
                const user = await auth.getUser() as IUser;
                if (user && user.id_token) {
                    setLoading(true);
                    try {
                        const headers = {
                            'Authorization': `Bearer ${user.id_token}`,
                            'Content-Type': 'application/json'
                        };

                        const resp = await fetch(process.env.REACT_APP_API_URL + "/api/v3.0/milestones?projectId=" + projectId, {
                            method: 'POST',
                            headers,
                            body: JSON.stringify(gridMetadata)
                        });

                        if (!resp.ok) {
                            // RESPOND TO ERRORS
                        }

                        const data = await resp.json() as GetProjectMilestonesResult;

                        setResult([...result, ...data.milestones]);

                        if (data.total !== total) {
                            setTotal(data.total);
                        }

                    } catch (err) {

                    } finally {
                        setLoading(false);
                    }
                } else {
                    // NOT LOGGED IN
                    setError('Not logged in');
                }
            })();
            return () => controller.abort();
        }, [projectId, gridMetadata]);

        return [
            result,
            total,
            loading,
            error
        ];
    }

export default useProjectMilestones;